<svg [ngClass]='cssClasses' [style.transform]="up ? 'rotateX(-180deg)' : ''" width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path
    d='M1.60078 0.904298L6.53846 5.85103L11.4761 0.904297L13 2.4309L6.53846 8.9043L0.0769216 2.43091L1.60078 0.904298Z'
    fill='#3A4146' />
</svg>
